export default "__VITE_ASSET__BI3X11GX__"